// Components
// Utils
import { hourMinuteToSecond, secondToHourMinute } from 'utils/timeConverter';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
import { Space } from '@timeedit/ui-components/antd';
// Types
import type { IProps } from './sections.interface';

const Properties = ({ timeRule, onChange, userIsSuper }: IProps) => {
  return (
    <TEDrawerSection label="Properties">
      <div className="section-wrapper">
        <Space direction="vertical">
          <TEInput.HoursMinuteInput
            label="Standard step"
            tooltip="Standard step"
            value={secondToHourMinute(timeRule.standardStep)}
            onChange={(val) =>
              onChange({ key: 'standardStep', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="standard-step"
            disabled={!userIsSuper}
          />
          <TEInput.HoursMinuteInput
            label="Minimum step"
            tooltip="Minimum step"
            value={secondToHourMinute(timeRule.minimumStep)}
            onChange={(val) =>
              onChange({ key: 'minimumStep', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="minimum-step"
            disabled={!userIsSuper}
          />
          <TEInput.HoursMinuteInput
            label="Begin step"
            tooltip="Begin step"
            value={secondToHourMinute(timeRule.beginStep)}
            onChange={(val) =>
              onChange({ key: 'beginStep', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="begin-step"
            disabled={!userIsSuper}
          />
        </Space>
        <Space direction="vertical">
          <TEInput.HoursMinuteInput
            label="Import step"
            tooltip="Import step"
            value={secondToHourMinute(timeRule.importStep)}
            onChange={(val) =>
              onChange({ key: 'importStep', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="import-step"
            disabled={!userIsSuper}
          />
          <TEInput.HoursMinuteInput
            label="Minimum length"
            tooltip="Minimum length"
            value={secondToHourMinute(timeRule.minimumLength)}
            onChange={(val) =>
              onChange({ key: 'minimumLength', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="minimum-length"
          />
          <TEInput.HoursMinuteInput
            label="Maximum length"
            tooltip="Maximum length"
            value={secondToHourMinute(timeRule.maximumLength)}
            onChange={(val) =>
              onChange({ key: 'maximumLength', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="maximum-length"
          />
        </Space>
        <Space direction="vertical">
          <TEInput.HoursMinuteInput
            label="Begin offset"
            tooltip="Begin offset"
            value={secondToHourMinute(timeRule.beginOffset)}
            onChange={(val) =>
              onChange({ key: 'beginOffset', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="begin-offset"
            disabled={!userIsSuper}
          />
          <TEInput.HoursMinuteInput
            label="Default length"
            tooltip="Default length"
            value={secondToHourMinute(timeRule.defaultLength)}
            onChange={(val) =>
              onChange({ key: 'defaultLength', value: hourMinuteToSecond(val) })
            }
            minuteStep={5}
            className="default-length"
          />
        </Space>
      </div>
    </TEDrawerSection>
  );
};

export default Properties;
